export default {
  // 可能是通用的
  Backup: 'Backup',
  Deep_thinking: 'Deep thinking',
  Upload_image: 'Upload image',
  Default: 'Default',
  // 独有
  toolInput: {
    TT: 'TT',
    think_only: 'Only supports DeepSeek R1',
    placeholder: 'Ask me anything...'
  }
}
